

import React, { useRef, useState } from 'react'
import { InputWrapper } from './style'
import { isEmpty } from '../../utils/common';



function Input({children,type="text", value="", name="", label="",error="", onChange=() =>{},onClick=() =>{},onFocus=()=>{},onBlur=()=>{},className="",toggle=false,potions=[],keys={value:"value",label:"label"},title="",...others}) {
    const [focus,setFocus] = useState("");
    const [passwordState, setPasswordState] = useState(true);
    const input = useRef();

    const focusInput = () =>{
    input.current.focus();
    onClick()
    }
  return (
    <InputWrapper className={className} title={title}>
    <div className={`inputField ${focus}`} onClick={()=>focusInput}
    onBlur={onBlur}
    onFocus={onFocus}
    title={title}
      >
    {/* <label htmlFor={name} title={name}>{label}</label> */}
  
  {(type !== "select") &&<>  <input ref={input}
    id={name}
    placeholder={label}
     type={type === "password"?`${passwordState?"password":"text"}`:type} value={value} name={name} onChange={onChange} {...others}  onFocus={()=>setFocus("focus")} onBlur={()=>setFocus("")} />
   { (toggle && type === "password") && <div className="toggel" onClick={() =>{setPasswordState(!passwordState)}}>{passwordState ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</div>}
    </>}

    {type === "select" && 
    <select value={value} name={name} onChange={onChange} {...others}  onFocus={()=>setFocus("focus")} onBlur={()=>setFocus("")}>
       {
         label &&  <option  value={""}>
       { label}
     </option>
       }
    {!isEmpty(potions) && potions.map((value, i) => {
        return (
            <option key={i} value={value[keys.value] ?? value}>
                {value[keys.label] ?? value}
            </option>
        );
    })}
</select>}
{children}
    </div>

    {!isEmpty(error)&&<div className="error">
       {error}

    </div>}
   
 
   
    
    </InputWrapper>
  )
}

export default Input;